<template>
  <Card class="contact-contracts">
    <template #default>
      <div class="row baseline between">
        <div class="card__title">{{ `${$tc('contract', 2)} (${value.length})` }}</div>
        <slot name="after-title" />
      </div>
      <div v-if="value.length" class="contact-contracts__items">
        <ContractCard
          tag="router-link"
          :to="{ name: 'contract', params: { id: item.id } }"
          v-for="item in value"
          :key="item.id"
          :value="item"
        />
      </div>
      <i v-else class="fade">{{ $t('noContracts') }}</i>
    </template>
    <template #footer>
      <slot name="actions" />
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import ContractCard from '@/components/Contract/Card'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ContractCard,
    Card,
  },
}
</script>

<style lang="scss">
.contact-contracts {
  &__items {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    max-height: 350px;
    overflow-y: auto;

    @include scrollShadow();
  }

  .contract-card {
    &:hover {
      background-color: rgba(black, 0.02);
    }
  }
}
</style>
